module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Mobile 2x.5e7e752d.png";